export default "__VITE_ASSET__5a0fa5ae__"